export const API_URL = String(import.meta.env.VITE_API_URL);
if (!API_URL) throw new Error("API_URL NOT SET");

export const BASE_URL = String(import.meta.env.VITE_BASE_URL);
if (!BASE_URL) throw new Error("BASE_URL NOT SET");

export const FILE_PATH = String(import.meta.env.VITE_FILE_PATH);
if (!FILE_PATH) throw new Error("FILE_PATH NOT SET");

export const ROOT_SLUG = String(import.meta.env.VITE_ROOT_CATEGORY_ID);
if (!ROOT_SLUG) throw new Error("ROOT_CATEGORY NOT SET");

export const PUBLIC_VAPID_KEY = String(import.meta.env.VITE_PUBLIC_VAPID_KEY);
if (!PUBLIC_VAPID_KEY) throw new Error("PUBLIC_VAPID_KEY NOT SET");

export const MAX_FILES_SIZE = Number(import.meta.env.VITE_MAX_FILES_SIZE);
if (isNaN(MAX_FILES_SIZE)) throw new Error("MAX_FILES_SIZE NOT CORRECTLY SET");

export const MAX_FILE_SIZE = Number(import.meta.env.VITE_MAX_FILE_SIZE);
if (isNaN(MAX_FILE_SIZE)) throw new Error("MAX_FILE_SIZE NOT CORRECTLY SET");

export const MAX_FILES_AMOUNT = Number(import.meta.env.VITE_MAX_FILES_AMOUNT);
if (isNaN(MAX_FILES_AMOUNT)) throw new Error("MAX_FILE_SIZE NOT CORRECTLY SET");

export const MAX_ITEM_AMOUNT = Number(import.meta.env.VITE_MAX_ITEM_AMOUNT);
if (isNaN(MAX_ITEM_AMOUNT)) throw new Error("MAX_FILE_SIZE NOT CORRECTLY SET");
